/** @jsx h */
import { h } from 'preact'
import clsx from 'clsx'
import { useLabel } from '../use-label'
import { useGlobal } from '../use-global'
import { useState, useEffect, useRef } from 'preact/hooks'

const Step = ({
  isOpen,
  isDone,
  isEnabled,
  isHighlighted,
  onToggle,
  className,
  children,
  index,
  title,
  summary,
  summaryExtra
}) => {
  const [{ canvasConfig }] = useGlobal()
  const t = useLabel()
  const ref = useRef(null)
  const [scrollHeight, setScrollHeight] = useState(0)

  useEffect(() => {
    if (!ref.current) return
    const resizeObserver = new ResizeObserver(() => setScrollHeight(ref.current.scrollHeight))
    resizeObserver.observe(ref.current)
    return () => resizeObserver.disconnect()
  }, [])

  const isOpenClass = isOpen ? 'rcc_c_is-open' : ''
  const isCompleted = isDone && !isOpen && isHighlighted

  return (
    <div
      className={clsx('rcc_c_card-step', className, {
        'is-completed': isCompleted
      })}
    >
      <div
        className={clsx('rcc_c_card-step-header js-step-header rcc-relative rcc-mx-auto', isOpenClass, {
          'rcc-max-w-[560px] rcc-bg-primary rcc-p-5 rcc-pt-0': isDone && !isOpen && isHighlighted,
          'rcc-cursor-default': !isEnabled,
          'rcc-cursor-pointer': isEnabled,
          'rcc-max-w-[760px]': !isDone || isOpen || !isHighlighted
        })}
        onClick={onToggle}
      >
        <h3
          className={clsx('rcc-uppercase rcc-text-base rcc-font-normal  rcc-border-gray-very-light rcc-py-5 rcc-m-0', {
            'rcc-normal-case rcc-text-sm rcc-m-0 rcc-pb-0': isDone && !isOpen && isHighlighted,
            'rcc-text-gray-very-light': !isEnabled,
            'rcc-text-gray': isEnabled,
            'rcc-border-t-0': isDone && !isOpen && index === 0,
            'rcc-border-t': index !== 0 || isOpen,
            'rcc-text-right': canvasConfig.direction === 'rtl',
            'rcc-tracking-[1.5px]': canvasConfig.locale !== 'ar'
          })}
        >
          {canvasConfig.direction !== 'rtl' && (
            <span
              className={clsx('rcc-mr-2', {
                'rcc-hidden': isDone && !isOpen && isHighlighted
              })}
            >
              {index + 1}.
            </span>
          )}
          {title}
        </h3>
        {isDone && !isOpen && isHighlighted && (
          <div
            className={clsx('rcc-flex rcc-gap-4', {
              'rcc-flex-row-reverse': canvasConfig.direction === 'rtl'
            })}
          >
            <div
              className={clsx('rcc-flex-1 rcc-text-text', {
                'rcc-text-right': canvasConfig.direction === 'rtl'
              })}
            >
              <p className='rcc_c_card-info rcc-m-0' data-cs-mask={index === 3}>
                {summary}
              </p>
              {summaryExtra && (
                <p className='rcc_c_card-info rcc-mt-1 rcc-font-extralight rcc-text-sm'>{summaryExtra}</p>
              )}
            </div>
            {isEnabled && (
              <button
                aria-expanded={isOpen}
                aria-label={`${t('Global.Edit')} ${title}`}
                className='rcc_c_card-edit rcc-bg-transparent rcc-m-0 rcc-underline rcc-text-sm rcc-text-gray rcc-cursor-pointer'
              >
                {t('Global.Edit')}
              </button>
            )}
          </div>
        )}
      </div>

      <div
        className={clsx('rcc_c_card-step-content js-step-content rcc-text-text', isOpenClass)}
        style={isOpen && { maxHeight: scrollHeight }}
      >
        <div ref={ref} className='rcc_c_container-content rcc-max-w-[560px] rcc-m-auto rcc-pt-6 rcc-pb-12'>
          {isOpenClass ? children : null}
        </div>
      </div>
    </div>
  )
}

export default Step
